import { render, staticRenderFns } from "./TeacherWelcomePage.vue?vue&type=template&id=1306edea&scoped=true&"
import script from "./TeacherWelcomePage.vue?vue&type=script&lang=ts&"
export * from "./TeacherWelcomePage.vue?vue&type=script&lang=ts&"
import style0 from "./TeacherWelcomePage.vue?vue&type=style&index=0&id=1306edea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1306edea",
  null
  
)

export default component.exports